import React from "react";
import { SelectItem } from "@/components/ui/select";

// Short office name for any Betenbough location value ("Betenbough Odessa", "Odessa", "Northwest Lubbock" → "Odessa"/"Lubbock Northwest")
const BH_SHORT_BY_NAME = {
  "betenbough midland": "Midland", "midland": "Midland",
  "betenbough odessa": "Odessa", "odessa": "Odessa",
  "betenbough lubbock northwest": "Lubbock Northwest", "lubbock northwest": "Lubbock Northwest", "northwest lubbock": "Lubbock Northwest",
  "betenbough lubbock south": "Lubbock South", "lubbock south": "Lubbock South", "south lubbock": "Lubbock South",
  "betenbough lubbock west": "Lubbock West", "lubbock west": "Lubbock West", "west lubbock": "Lubbock West",
  "betenbough amarillo": "Amarillo", "amarillo": "Amarillo",
};

export const bhLocationShort = (value) =>
  BH_SHORT_BY_NAME[(value || "").trim().replace(/\s+/g, " ").toLowerCase()] || "";

const uniqueSorted = (names) => {
  const seen = new Map();
  names.forEach((n) => {
    const name = (n || "").trim();
    if (name && !seen.has(name.toLowerCase())) seen.set(name.toLowerCase(), name);
  });
  return [...seen.values()].sort((a, b) => a.localeCompare(b));
};

// Preferred = lender accounts assigned to the selected office in the Lender Editor
export const getLenderGroups = (location, apiByLocation = {}, apiLenders = []) => {
  const short = bhLocationShort(location);
  const preferred = short ? uniqueSorted(apiByLocation[short] || []) : [];
  const preferredKeys = new Set(preferred.map((n) => n.toLowerCase()));
  return { short, preferred, others: uniqueSorted(apiLenders).filter((n) => !preferredKeys.has(n.toLowerCase())) };
};

export const LenderSelectItems = ({ location, apiByLocation, apiLenders, testIdPrefix = "lender" }) => {
  const { short, preferred, others } = getLenderGroups(location, apiByLocation, apiLenders);
  if (!preferred.length) {
    return others.map((n) => <SelectItem key={n} value={n} data-testid={`${testIdPrefix}-option-${n}`}>{n}</SelectItem>);
  }
  return (
    <>
      <div className="px-2 py-1.5 text-xs font-semibold text-slate-500 bg-slate-50" data-testid={`${testIdPrefix}-preferred-header`}>{short} Lenders</div>
      {preferred.map((n) => <SelectItem key={`p-${n}`} value={n} data-testid={`${testIdPrefix}-preferred-${n}`}>{n}</SelectItem>)}
      <div className="px-2 py-1.5 text-xs font-semibold text-slate-500 bg-slate-50 mt-1">Other Lenders</div>
      {others.map((n) => <SelectItem key={`o-${n}`} value={n} data-testid={`${testIdPrefix}-option-${n}`}>{n}</SelectItem>)}
    </>
  );
};
